export default __webpack_public_path__ + "static/media/wcehub.a86a2182.png";